import { render, staticRenderFns } from "./announcemenMail.vue?vue&type=template&id=4dfb1e92&"
import script from "./announcemenMail.vue?vue&type=script&lang=js&"
export * from "./announcemenMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/home/ctrl/announcemenMail/announcemenMail.vue"
export default component.exports